import * as React from 'react';
import { useUpdateEffect } from '@cian/react-utils';
export function useDropdownController(_ref) {
  let {
    disabled,
    readOnly
  } = _ref;
  const [open, setOpen] = React.useState(false);
  const canOpen = !disabled && !readOnly;
  const openDropdown = () => {
    if (canOpen) {
      setOpen(true);
    }
  };
  const closeDropdown = () => setOpen(false);
  const toggleDropdown = () => {
    setOpen(open => {
      if (open) {
        return false;
      } else {
        return canOpen ? true : false;
      }
    });
  };
  useUpdateEffect(() => {
    if (!canOpen) {
      closeDropdown();
    }
  }, [canOpen]);
  return {
    open,
    actions: {
      openDropdown,
      closeDropdown,
      toggleDropdown
    }
  };
}